import { Component } from "react";
import { getFormattedDate } from "../../consts";
import React from "react";

class DateCustomInput extends Component {
    getText() {
        const { logsStartDate, logsEndDate, placeholder } = this.props;
        if (!logsStartDate) return placeholder || "";
        const t1 = getFormattedDate({ date: logsStartDate, dateOnly: true });
        const t2 = getFormattedDate({ date: logsEndDate, dateOnly: true });
        return t1 === t2 || !logsEndDate ? t1 : t1 + ' - ' + t2;
    }

    render() {
        return <button className="date-custom-input" onClick={this.props.onClick}>
            {this.getText()}
        </button>
    }

};

export default DateCustomInput;